<template>
  <div class="content-custom-pj">
    <h4>
      <v-icon name="settings" class="icon-custom1"></v-icon> E-Form Settings
    </h4>
    <b-alert show variant="dark">
      <div>
        <eFormAdds v-bind:my-eform-id="this.eFormId"></eFormAdds>
      </div>
      <div>
        <md-table md-sort-order="asc" md-card>
          <md-table-toolbar>
            <div class="md-toolbar-section-start">
              <md-button class="md-fab md-mini md-primary">
                <md-icon>add</md-icon>
              </md-button>
            </div>
            <md-field class="md-toolbar-section-end">
              <md-input placeholder="Search by form name..." />
            </md-field>
          </md-table-toolbar>
          <md-table-row>
            <md-table-head md-numeric>Order</md-table-head>
            <md-table-head>Form Name</md-table-head>
            <md-table-head>Department</md-table-head>
            <md-table-head>User Create</md-table-head>
            <md-table-head>Action</md-table-head>
          </md-table-row>

          <md-table-row>
            <md-table-cell md-numeric>1</md-table-cell>
            <md-table-cell>ทดสอบ 1</md-table-cell>
            <md-table-cell>ศูนย์คอมพิวเตอร์</md-table-cell>
            <md-table-cell>PERJER4675</md-table-cell>
            <md-table-cell>Assistant Media Planner</md-table-cell>
          </md-table-row>
          <md-table-row>
            <md-table-cell md-numeric>2</md-table-cell>
            <md-table-cell>ทดสอบ 2</md-table-cell>
            <md-table-cell>อายุรกรรม</md-table-cell>
            <md-table-cell>PERJER4675</md-table-cell>
            <md-table-cell>Assistant Media Planner</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import store from "@/store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

import eFormAdds from "@/components/Settings/eForms/eFormAdds";

Vue.component("eFormAdds", eFormAdds);

@Component({
  component: {
    store,
    axios,
    VueAxios,
    thaiDatetime,
    pjFunctions
  },
  data() {
    return {
      show: false,
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        },
        MyScanDate: this.MyScanDate,
        MyHn: this.MyHn,
        MyScanType: this.MyScanType
      },
      eFormId: "New"
    };
  },
  mounted() {},
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
  },
  methods: {}
})
export default class eFormSettings extends Vue {}
</script>


<style lang="scss">
</style>
